import { render, staticRenderFns } from "./PCConncatUs.vue?vue&type=template&id=138d39de&scoped=true"
import script from "./PCConncatUs.vue?vue&type=script&lang=js"
export * from "./PCConncatUs.vue?vue&type=script&lang=js"
import style0 from "./PCConncatUs.vue?vue&type=style&index=0&id=138d39de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d39de",
  null
  
)

export default component.exports